import { useQuery } from "@tanstack/react-query";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "../trpc";

export function useInductionSummary() {
  const { merchant } = useMerchant();
  const trpc = useProtectTRPC();
  const rentalsMerchantId = merchant?.id ?? "";

  const { data, isPending, isError } = useQuery({
    ...trpc.induction.summary.queryOptions({ rentalsMerchantId }),
    enabled: !!rentalsMerchantId,
  });

  return {
    summary: data,
    isLoading: !rentalsMerchantId || isPending,
    isError,
  };
}
